"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("./utils");
// eslint-disable-next-line complexity
function compileMarkdownStyle(branding) {
    var _a, _b, _c, _d;
    const { markdown = {} } = branding;
    const textDecoration = (_b = (_a = markdown === null || markdown === void 0 ? void 0 : markdown.href) === null || _a === void 0 ? void 0 : _a.textDecoration) !== null && _b !== void 0 ? _b : '';
    const [line, style] = textDecoration.split(' ');
    return (0, utils_1.process)({
        'markdown-font-size': markdown === null || markdown === void 0 ? void 0 : markdown.fontSize,
        'markdown-font-weight': markdown === null || markdown === void 0 ? void 0 : markdown.fontWeight,
        'markdown-line-height': markdown === null || markdown === void 0 ? void 0 : markdown.lineHeight,
        'markdown-h1-font-size': markdown === null || markdown === void 0 ? void 0 : markdown.h1FontSize,
        'markdown-h1-font-weight': markdown === null || markdown === void 0 ? void 0 : markdown.h1FontWeight,
        'markdown-h1-line-height': markdown === null || markdown === void 0 ? void 0 : markdown.h1LineHeight,
        'markdown-h2-font-size': markdown === null || markdown === void 0 ? void 0 : markdown.h2FontSize,
        'markdown-h2-font-weight': markdown === null || markdown === void 0 ? void 0 : markdown.h2FontWeight,
        'markdown-h2-line-height': markdown === null || markdown === void 0 ? void 0 : markdown.h2LineHeight,
        'markdown-h3-font-size': markdown === null || markdown === void 0 ? void 0 : markdown.h3FontSize,
        'markdown-h3-line-height': markdown === null || markdown === void 0 ? void 0 : markdown.h3LineHeight,
        'markdown-href-color': (_c = markdown === null || markdown === void 0 ? void 0 : markdown.href) === null || _c === void 0 ? void 0 : _c.color,
        'markdown-href-hover-color': (_d = markdown === null || markdown === void 0 ? void 0 : markdown.href) === null || _d === void 0 ? void 0 : _d.hoverColor,
        'markdown-href-text-decoration-line': line,
        'markdown-href-text-decoration-style': style
    });
}
exports.default = compileMarkdownStyle;
